import { Directive, ElementRef, Input } from '@angular/core';
import { CarouselComponent } from '@df/ui-carousel/carousel.component';

@Directive({
    selector: '[twoDimensionalCarouselBullets]',
    standalone: true
})
export class TwoDimensionalCarouselBulletsDirective {
    @Input()
    set twoDimensionalCarouselBullets(value: number) {
        this.index = value;
    }

    public index = 0;

    constructor(
        public elementRef: ElementRef,
        public carousel: CarouselComponent
    ) {}
}
